// extracted by mini-css-extract-plugin
module.exports = {"tenant-avatar":"TenantAvatar_tenant-avatar__BiCXs","small":"TenantAvatar_small__2mrog","medium":"TenantAvatar_medium__3Vd6g","highlighted":"TenantAvatar_highlighted__3-oa0"};